import Grupo from "../../../../models/Grupo";
import CustomHandle from "../../../../utils/CustomHandle";

// Teto da lista carregada de uma vez (o backend aceita ate 500 por pagina).
const LIMITE_LISTA = 200;

class ControllerGrupos {
  constructor(usuario, errors, setErrors, setLoading, page, setPage, search, setSearch, grupos, setGrupos, meusGrupos, setMeusGrupos, pageMeusGrupos, setPageMeusGrupos ) {
    this.usuario = usuario;
    this.setLoading = setLoading;
    this.errors = errors;
    this.setErrors = setErrors;
    this.page = page;
    this.setPage = setPage;
    this.search = search;
    this.setSearch = setSearch;
    this.meusGrupos = meusGrupos;
    this.setMeusGrupos = setMeusGrupos;
    this.pageMeusGrupos = this.pageMeusGrupos; 
    this.setPageMeusGrupos = this.setPageMeusGrupos;
    this.grupos = grupos;
    this.setGrupos = setGrupos;
    this.pageMeusGrupos = pageMeusGrupos;
    this.setPageMeusGrupos = setPageMeusGrupos; 
  }

  // A tela PAGINA no site (components/Paginacao), entao carrega a lista inteira de uma
  // vez (ate LIMITE_LISTA). Antes pedia `/6` ao servidor e NAO tinha botao de pagina:
  // do 7o grupo em diante ninguem via nada. E "Grupos para conhecer" tira os grupos em
  // que a pessoa ja participa DEPOIS de paginar, o que deixava paginas incompletas e o
  // total errado -- paginando aqui, depois do filtro, a conta fecha.
  async findMeusGrupos(){
    this.setLoading(true);

    const result = await Grupo.findByUsuarioId(this.usuario.id, 1, this.search, LIMITE_LISTA);

    CustomHandle.handleResult(result, this.errors, this.setErrors, (response) => {
      this.setMeusGrupos(response);
    });

    this.setLoading(false);
  }

  async participar(grupo, setGrupo){
    this.setLoading(true);

    const result = await Grupo.participar(this.usuario.id, grupo.id);
    
    const onSuccess = (response)=>{
      setGrupo({...grupo, is_solicitado : !grupo.is_solicitado });
    };

    CustomHandle.handleResult(result, this.errors, this.setErrors, onSuccess);

    this.setLoading(false);
  }

  handleSearch(e, typingTimeout, setTypingTimeout){
    clearTimeout(typingTimeout);
    const newTypingTimeout = setTimeout(() => {
      // Nao zera as listas: a tela mantem as antigas (mais claras) ate a busca responder.
      this.setSearch(e.target.value);
      if(this.pageMeusGrupos!==1){
        this.setPageMeusGrupos(1);
      }
      if(this.page !== 1){
        this.setPage(1);
      }
    }, 500);
    setTypingTimeout(newTypingTimeout);
  };

  async findAllGrupos(){
    this.setLoading(true);

    const result = await Grupo.findAll(1, this.search, LIMITE_LISTA);

    CustomHandle.handleResult(result, this.errors, this.setErrors, (response) => {
      const rows = response.rows.filter(grupo => !grupo.is_participante);
      this.setGrupos({ ...response, rows, count: rows.length });
    });

    this.setLoading(false);
  }
}

export default ControllerGrupos;
